import React, { useState } from "react";
import {
  Card,
  Button,
  Table,
  Modal,
  Form,
  Input,
  Select,
  Space,
  Spin,
  Tag,
  message,
} from "antd";
import { PlusOutlined, EditOutlined, DeleteOutlined } from "@ant-design/icons";
import {
  useFetchAllergensQuery,
  useCreateAllergenMutation,
  useUpdateAllergenMutation,
  useDeleteAllergenMutation,
} from "./label.service";

const { Column } = Table;
const { Option } = Select;

export default function AllergenManagement() {
  const [form] = Form.useForm();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [editingAllergen, setEditingAllergen] = useState(null);
  const [deleteLoading, setDeleteLoading] = useState("");

  const { data: allergensData, isLoading, refetch } = useFetchAllergensQuery();
  const [createAllergen, { isLoading: isCreating }] = useCreateAllergenMutation();
  const [updateAllergen, { isLoading: isUpdating }] = useUpdateAllergenMutation();
  const [deleteAllergen] = useDeleteAllergenMutation();

  const allergens = allergensData?.data?.allergens || [];

  const handleAdd = () => {
    setEditingAllergen(null);
    form.resetFields();
    setIsModalVisible(true);
  };

  const handleEdit = (record) => {
    setEditingAllergen(record);
    form.setFieldsValue({
      name: record.name,
      type: record.type,
      description: record.description,
    });
    setIsModalVisible(true);
  };

  const handleDelete = (id, name) => {
    Modal.confirm({
      title: "Delete Allergen",
      content: `Are you sure you want to delete "${name}"?`,
      onOk: async () => {
        setDeleteLoading(id);
        try {
          await deleteAllergen(id).unwrap();
          message.success("Allergen deleted successfully");
          refetch();
        } catch (error) {
          message.error(error?.data?.message || "Failed to delete allergen");
        } finally {
          setDeleteLoading("");
        }
      },
    });
  };

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      if (editingAllergen) {
        await updateAllergen({ id: editingAllergen._id, data: values }).unwrap();
        message.success("Allergen updated successfully");
      } else {
        await createAllergen(values).unwrap();
        message.success("Allergen created successfully");
      }
      setIsModalVisible(false);
      form.resetFields();
      refetch();
    } catch (error) {
      message.error(error?.data?.message || "Operation failed");
    }
  };

  const getTypeTag = (type) => {
    const colors = {
      ALLERGEN: "red",
      MAY_CONTAIN: "orange",
    };
    return <Tag color={colors[type] || "default"}>{type || "ALLERGEN"}</Tag>;
  };

  return (
    <Card
      title="Allergens Management"
      extra={
        <Button type="primary" icon={<PlusOutlined />} onClick={handleAdd}>
          Add Allergen
        </Button>
      }
    >
      <Spin spinning={isLoading}>
        <Table dataSource={allergens} rowKey="_id" pagination={{ pageSize: 10 }}>
          <Column title="Name" dataIndex="name" />
          <Column title="Type" dataIndex="type" render={getTypeTag} />
          <Column title="Description" dataIndex="description" ellipsis />
          <Column
            title="Actions"
            align="center"
            render={(_, record) => (
              <Space>
                {/* <Button
                  icon={<EditOutlined />}
                  size="small"
                  onClick={() => handleEdit(record)}
                /> */}


       

                           <Button
                                        className="team-page-container-content-tool"
                                        color="green"
                                        variant="solid"
                                        icon={<EditOutlined />}
                                        onClick={() => handleEdit(record)}
                                      >
                                        Edit
                                      </Button>

                {/* <Button
                  icon={<DeleteOutlined />}
                  size="small"
                  danger
                  loading={deleteLoading === record._id}
                  onClick={() => handleDelete(record._id, record.name)}
                /> */}

                         <Button
                                         className="team-page-container-content-tool"
                                                         variant="solid"
                                                         color="danger"
                                                         size="small"
                                                         icon={<DeleteOutlined />}
                                 loading={deleteLoading === record._id}
                  onClick={() => handleDelete(record._id, record.name)}
                                                      >
                                                       Delete
                                                      </Button>
              </Space>
            )}
          />
        </Table>
      </Spin>

      <Modal
        title={editingAllergen ? "Edit Allergen" : "Add Allergen"}
        open={isModalVisible}
        onOk={handleSubmit}
        onCancel={() => setIsModalVisible(false)}
        confirmLoading={isCreating || isUpdating}
      >
        <Form form={form} layout="vertical">
          <Form.Item
            name="name"
            label="Allergen Name"
            rules={[{ required: true, message: "Please enter allergen name" }]}
          >
            <Input placeholder="e.g., NUTS, DAIRY, GLUTEN, SHELLFISH" />
          </Form.Item>
          <Form.Item
            name="type"
            label="Type"
            rules={[{ required: true, message: "Please select type" }]}
            initialValue="ALLERGEN"
          >
            <Select>
              <Option value="ALLERGEN">Allergen</Option>
              <Option value="MAY_CONTAIN">May Contain</Option>
            </Select>
          </Form.Item>
          <Form.Item name="description" label="Description">
            <Input.TextArea rows={3} placeholder="Enter description (optional)" />
          </Form.Item>
        </Form>
      </Modal>
    </Card>
  );
}